/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/components/modals/legacyDialog.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'components/modals/legacyDialog', exports: {} }; const exports = module.exports;

import $ from '@grins/fd-modules/jQuery';

import MicroModal from '@grins/fd-modules/MicroModal';

const Styles = {
    OPEN: 'open',
}
const EventNames = Object.freeze({
    CLOSED: 'close',
    OPENED: 'open',
})
class LegacyDialog {
    constructor(dialogID, opts) {
        this.id = dialogID.replace('#', '');
        this.opts = {
            closeOnBgClick: true,
            closeOnEsc: true,
            ...opts
        };
        if (this.opts.closeOnBgClick) {
            const bgOverlay = document.getElementById(this.id);
            bgOverlay && (bgOverlay.dataset.micromodalClose = 'true');
        }
    }
    close() {
        MicroModal.close(this.id);
        return this;
    }
    open() {
        MicroModal.show(this.id, {
            awaitCloseAnimation: false,
            debugMode: true,
            disableCloseOnEscape: !this.opts.closeOnEsc,
            disableScroll: true,
            onClose: () => {
                this.emit && this.emit(EventNames.CLOSED);
            },
            onShow: () => {
                this.emit && this.emit(EventNames.OPENED);
            },
            openClass: Styles.OPEN,
        });
        return this;
    }
    static EventNames = EventNames;
}
$.extend(LegacyDialog.prototype, $.eventEmitter);
export default LegacyDialog;